<template>
  <base-button :route="route"
               :text="text"
               :title="title"
               :fa-class="faClass"
               :fa-position="faPosition"
               :class="bootstrapClass"
  />
</template>

<script>
import baseButton from '@/components/backoffice/button/base'

export default {
  components: {
    baseButton
  },
  props: {
    route: {
      type: Object,
      required: true
    },
    text: {
      type: String,
      default: '_edit'
    },
    title: {
      type: String,
      default: '_edit'
    },
    faClass: {
      type: String,
      default: 'edit'
    },
    faPosition: {
      type: String,
      default: null
    },
    bootstrapClass: {
      type: String,
      default: 'bg-primary'
    }
  }
}
</script>
